import React, { Fragment } from 'react'
import { Button, Card, Col, Container, CardBody, Input} from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ModalDiscountTest } from './ExamDiscount/ModalDiscountTest';
import { useCatalogDiscountExams } from '../../hooks/discounts/useCatalogDiscountExams';
import '../admission/viewWorkOrderDay/styleDataTable.css'
import '../discounts/ExamDiscount/styleDataTableDiscount.css'
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';

export const IndexCatalogDiscountExams = () => {

    const {
        listTestDiscounts, handleDiscountTestExam, modal, method, closeDialog, handleInputChange, enable_discounts, currentExam, handleSaveDiscount,
        setSearch, search, loading, 
         loadingExport, handleExportExcelDiscount,
         handleSearch, handleClearDiscountExam, searchDiscount


       

    } = useCatalogDiscountExams()


     const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };
    
    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleDiscountTestExam(rowData)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>
            </div>
        );
    };

    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Col sm="12">
                    <Card>
                        <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                            <TitleDataTable
                                titleTable="Listado de exámenes con descuentos"
                                buttonActions={handleExportExcelDiscount}
                                showCreateButton={false}
                                titleButton="Listado de exámenes con descuento"
                                isDisbled={loadingExport}
                                loadingIsDisabled={loadingExport}
                                actionInput={handleSearch}
                                valueFilter={searchDiscount}
                                filterLocalStorage={true}
                                cleanFilterLocalStorage={handleClearDiscountExam}

                            />
                        </Col>
                        <div className="table-responsive">
                            <DataTable
                                value={listTestDiscounts}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 50, 100]}
                                responsiveLayout="scroll"
                                className="data-table p-datatable-striped p-datatable-sm"
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "32%" }}
                                            alt="Sin resultados"
                                        />
                                        <br />
                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                            No se encontraron resultados.
                                        </p>
                                    </div>
                                }
                                                                
                            >
                                <Column 
                                    field="name" 
                                    header="Exámenes" 
                                    sortable 
                                    headerStyle={{ ...headerStyle, width: '50%' }}
                                    style={{ ...cellStyle, width: '50%' }}
                                />

                                <Column 
                                    field="enable_discounts" 
                                    header="Aplica Descuento" 
                                    body={(rowData) => (rowData.enable_discounts ? 'Sí' : 'No')} 
                                    sortable  
                                    headerStyle={{ ...headerStyle, width: '25%' }}
                                    style={{ ...cellStyle, width: '25%' }}
                                />

                                <Column 
                                    header="Acciones" 
                                    body={actions} 
                                    exportable={false} 
                                    headerStyle={{ ...headerStyle, width: '25%' }}
                                    style={{ ...centerStyle, width: '25%' }}
                                />

                            </DataTable>


                        </div>
                
                    </Card><br />
                </Col>
            </div>

            <ModalDiscountTest
                {...{ modal, method, closeDialog, handleInputChange, enable_discounts, currentExam, handleSaveDiscount
                }}
            />
        </Fragment>
    )
}
